import { question21, question22, question23, question24 } from "assets/images";
import CustomButton from "components/form";
import React from "react";

const Question3 = ({ setStyleIdentityContent, styleIdentityContent, addOrUpdateQuestion,buttonLoaders ,errors}) => {
  // Handles input changes for titles and descriptions within styleIdentityContent
  const handleInputChange = (index, field, value) => {
    const updatedContent = [...styleIdentityContent.styleIdentityContent];
    updatedContent[index][field] = value;
    setStyleIdentityContent({ ...styleIdentityContent, styleIdentityContent: updatedContent });
  };

  return (
    <>
      <div className="form_field page_title">
        <label className="label">Screen Title</label>
        <input
          type="text"
          className="form-control input"
          placeholder="Enter Title"
          value={styleIdentityContent.styleIdentityContentHeading}
          onChange={(e) => setStyleIdentityContent({ ...styleIdentityContent, styleIdentityContentHeading: e.target.value })}
        />
               {errors.styleIdentityContentHeading && (
          <span className="error">{errors.styleIdentityContentHeading}</span>
        )}
      </div>

      <h4>Options to Answer</h4>

      <div className="card_wrap pick_shape step2">
        {styleIdentityContent.styleIdentityContent.map((item, index) => (
          <div className="item" key={index}>
            <div className="_card">
              <img
                src={
                  index === 0 ? question21 :
                  index === 1 ? question22 :
                  index === 2 ? question23 : question24
                }
                alt=""
              />
            </div>
            <div className="input_content">
              <span className="card_tag">
                {index === 0 ? "Bold Boss" :
                 index === 1 ? "Dreamy Diva" :
                 index === 2 ? "Timeless Queen" : "Effortless Chic"}
              </span>
              <div className="form_field">
                <input
                  type="text"
                  className="form-control input"
                  placeholder="Enter Title"
                  value={item.title}
                  onChange={(e) => handleInputChange(index, "title", e.target.value)}
                />
                  {errors[`styleIdentityContentTitle${index}`] && (
                  <span className="error">{errors[`styleIdentityContentTitle${index}`]}</span>
                )}
              </div>
              <div className="form_field">
                <input
                  type="text"
                  className="form-control input"
                  placeholder="Enter Description"
                  value={item.description || ""}
                  onChange={(e) => handleInputChange(index, "description", e.target.value)}
                />
                   {errors[`styleIdentityContentDescription${index}`] && (
                  <span className="error">{errors[`styleIdentityContentDescription${index}`]}</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="button_wrap">
        <CustomButton  ref={buttonLoaders} onClick={addOrUpdateQuestion}>Save</CustomButton>
      </div>
    </>
  );
};

export default Question3;
